function headerFixedToggle() {

	if ($(window).width() >1279) {
		const header = $('.jsHeader');
		const headerSourceBottom = header.outerHeight();
		if (header.hasClass('header--fixed') && window.pageYOffset < headerSourceBottom) {
			header.removeClass('header--fixed');
		} else if (window.pageYOffset > headerSourceBottom) {
			header.addClass('header--fixed');
		}
	}



}

$(document).ready(function(){
	headerFixedToggle();

	$('.jsMenuMobileTrigger, .jsHeaderClose').on('click',function () {
		$('html').toggleClass('is-fixed');
		$('.jsHeader').toggleClass('is-active');
		$('.jsHeaderOverlay').toggleClass('is-active');
	});

	$('.jsHeaderOverlay').on('click',function () {
		$('html').toggleClass('is-fixed');
		$('.jsHeaderOverlay').toggleClass('is-active');

		if ($('.jsHeader').hasClass('is-active')) {
			$('.jsHeader').toggleClass('is-active');
		}

		if ($('.jsSearchBlock').hasClass('is-active')) {
			$('.jsSearchBlock').toggleClass('is-active');
		}
	});

	$('.jsNavItemTrigger ').on('click',function () {
		$(this).toggleClass('is-active');
		$(this).prev('.nav__item-dropdown').slideToggle(350);
	});

	$(window).on('scroll', function() {
		headerFixedToggle();
	});



	$('.jsMenuTrigger ').on('click',function () {
		$('.jsMenu').toggleClass('is-active');
		$('html').toggleClass('is-fixed');
	});


	$('.jsSearchTrigger').on('click', function () {
		$('.jsSearchBlock').toggleClass('is-active');
		$('.jsHeaderOverlay').toggleClass('is-active');
	})



});
